import React, { Component } from 'react';

import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

// eslint-disable-next-line react/prefer-stateless-function
class PrivateRoute extends Component {
  render() {
    const { component: PComponent, ...rest } = this.props;
    const { loggedIn } = this.props.auth;
    return (
      <Route
        {...rest}
        render={props =>
          loggedIn ? (
            <PComponent {...props} />
          ) : (
            <Redirect to={{ pathname: '/auth', state: { from: props.location } }} />
          )
        }
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {})(PrivateRoute);
